// eslint-disable-next-line import/prefer-default-export
export const SmallScreenWidthBreakpoint: number = 1200;
export const ExtraSmallScreenWidthBreakpoint: number = 400;
